<template>
    <v-card class="mx-auto" outlined>
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-title class="headline mb-1">Ops  :( </v-list-item-title>
        <p>Spiacenti si è verificato un'errore, se il problema persiste contattaci. <br>Grazie</p>
      </v-list-item-content>
    </v-list-item>

    <v-card-actions>
        <v-btn text outlined depressed @click="gohome()"  ripple color="#000000" style="background-color:#cccccc" >OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
    name: "error",
    methods:{
        gohome: function(){
            this.$router.push("/")
        }
    }
}
</script>